import ArtPlaceholder from "./ArtPlaceholder";
import { fmtPrice } from "../utils/format";
import { mediaSrc, isVideo } from "../utils/media";
import "../styles/ArtCard.css";

export default function ArtCard({ item, onClick, actions, variant }) {
  const video = isVideo(item);
  const gallery = variant === "gallery";
  const src = mediaSrc(item.img);

  return (
    <div className="art-card" onClick={onClick}>
      <div className="art-card-img">
        {src && video ? (
          <video src={src} muted playsInline preload="metadata" />
        ) : src ? (
          <img src={src} alt={item.title || "Artwork"} />
        ) : (
          <ArtPlaceholder />
        )}
        {video && <span className="media-badge">Video</span>}
      </div>
      {!gallery && (
        <div className="art-card-body">
          <div className="art-card-medium">{item.category}</div>
          <div className="art-card-title">{item.title}</div>
          {item.details && (
            <div className="art-card-detail">
              {item.details.substring(0, 72)}{item.details.length > 72 ? "…" : ""}
            </div>
          )}
          {item.price != null && item.price !== "" && (
            <div className="art-card-price">{fmtPrice(item.price)}</div>
          )}
          {actions && <div className="art-card-actions">{actions}</div>}
        </div>
      )}
      {gallery && item.title && item.title !== "Untitled" && (
        <div className="art-card-body art-card-body-minimal">
          <div className="art-card-title">{item.title}</div>
        </div>
      )}
    </div>
  );
}
